import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6 13H18V11H6V13ZM3 6V8H21V6H3ZM10 18H14V16H10V18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Filter2"
);
